export default "__VITE_ASSET__D0ERlJwe__"